function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "#EA7125",
  d: "M33 52h2v-6h-2zM45 52h2v-6h-2zM51 33h-1c-1.654 0-3-1.346-3-3v-2a1 1 0 00-1-1h-1v-1.382L42.236 27H34a1 1 0 00-1 1v2c0 1.654-1.346 3-3 3v-2a1 1 0 001-1v-2c0-1.654 1.346-3 3-3h7.764L47 22.382v2.789c1.164.413 2 1.525 2 2.829v2a1 1 0 001 1h1v2"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M29 33h1v-2h-1z"
}), React.createElement("path", {
  d: "M30 34.586l1 1V36c0 4.253 2.443 11 9 11s9-6.747 9-11v-.414l1-1V22c0-1.654-1.346-3-3-3H36c-1.103 0-2 .897-2 2v1h-2c-1.103 0-2 .897-2 2v10.586zM40 49c-7.794 0-10.832-7.541-10.993-12.579L28 35.414V24c0-2.206 1.794-4 4-4h.127A4.005 4.005 0 0136 17h11c2.757 0 5 2.243 5 5v13.414l-1.007 1.007C50.832 41.459 47.794 49 40 49zM28.908 55.754l6.87 3.054L39 55.586v-.805l-6.762-1.691-3.33 2.664zm7.314 5.438l-11.13-4.946 6.67-5.336L41 53.219v3.195l-4.778 4.778z",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M41 55.586l3.222 3.222 6.87-3.054-3.33-2.664L41 54.781v.805zm2.778 5.606L39 56.414v-3.195l9.238-2.309 6.67 5.336-11.13 4.946z",
  fill: "#EA7125"
}), React.createElement("path", {
  fill: "#A5ACB0",
  d: "M39 67h2v-2h-2zM39 63h2v-2h-2z"
}), React.createElement("path", {
  d: "M17.877 61.479l-1.772-.926c.199-.396 1.494-2.474 7.579-4.501l3-1 .632 1.896-3 1c-5.347 1.783-6.428 3.515-6.439 3.531M62.105 61.447c-.001 0-1.097-1.723-6.421-3.499l-3-1 .632-1.896 3 1c6.085 2.027 7.38 4.105 7.579 4.501l-1.79.894",
  fill: "#EA7125"
}), React.createElement("path", {
  d: "M40 10c-16.542 0-30 13.458-30 30s13.458 30 30 30 30-13.458 30-30-13.458-30-30-30zm0 62C22.355 72 8 57.645 8 40S22.355 8 40 8s32 14.355 32 32-14.355 32-32 32z",
  fill: "#A5ACB0"
}), React.createElement("path", {
  d: "M0 0h80v80H0z"
}));

var SvgIconIllustrationPortrait = function SvgIconIllustrationPortrait(props) {
  return React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80"
  }, props), _ref);
};

export default SvgIconIllustrationPortrait;